// --- Script Block 1: Flying Pastry Animation ---
window.initFlyingPastry = function () {
  var pp = document.querySelector(".pp");
  var fly = document.getElementById("ppFly");
  var hero = document.getElementById("ppHero");
  var slot = document.getElementById("ppSlot");

  if (!pp || !fly || !hero) return; // If slot is missing, we fall back to static layout

  var mqSmall = window.matchMedia("(max-width:860px)");
  var mqReduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  var start = null,
    end = null,
    landScroll = 1;

  function layout() {
    // Re-query dynamically to ensure we use fresh DOM elements in Theme Editor
    pp = document.querySelector(".pp");
    fly = document.getElementById("ppFly");
    hero = document.getElementById("ppHero");
    slot = document.getElementById("ppSlot");

    if (!pp || !fly || !hero) return;

    if (!slot || mqSmall.matches || mqReduce.matches) {
      fly.classList.add("static");
      fly.style.cssText = "";
      return;
    }

    fly.classList.remove("static");
    var b = pp.getBoundingClientRect(),
      bx = b.left + window.scrollX,
      by = b.top + window.scrollY;
    var hr = hero.getBoundingClientRect(),
      hx = hr.left + window.scrollX,
      hy = hr.top + window.scrollY;
    var sr = slot.getBoundingClientRect(),
      sx = sr.left + window.scrollX + sr.width / 2,
      sy = sr.top + window.scrollY + sr.height / 2;

    start = {
      x: hx + hr.width / 2 - bx,
      y: hy + hr.height * 0.44 - by,
      w: Math.min(hr.width * 0.26, 340),
    };
    end = { x: sx - bx, y: sy - by, w: sr.width };
    landScroll = Math.max(sy - window.innerHeight * 0.5, 1);
    tick();
  }

  function tick() {
    if (!fly || fly.classList.contains("static")) return;
    var p = Math.min(Math.max(window.scrollY / landScroll, 0), 1);
    var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
    var x = start.x + (end.x - start.x) * e,
      y = start.y + (end.y - start.y) * e,
      w = start.w + (end.w - start.w) * e;
    fly.style.width = w + "px";
    fly.style.left = "0";
    fly.style.top = "0";
    fly.style.transform =
      "translate(" + (x - w / 2) + "px," + (y - w / 2) + "px)";
  }

  window.removeEventListener("scroll", window._tickHandler);
  window._tickHandler = function () {
    requestAnimationFrame(tick);
  };
  window.addEventListener("scroll", window._tickHandler, { passive: true });

  window.removeEventListener("resize", window._resizePastryHandler);
  window._resizePastryHandler = layout;
  window.addEventListener("resize", window._resizePastryHandler);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(layout);
  }

  setTimeout(layout, 400);
  setTimeout(layout, 1200);

  if (mqSmall.addEventListener) {
    mqSmall.removeEventListener("change", layout);
    mqSmall.addEventListener("change", layout);
  }

  layout();
};

// --- Script Block 2: Skating Panda Slide-in Animation ---
window.initSkatingPanda = function () {
  var sec = document.getElementById("ppPandaSec");
  var slide = document.getElementById("ppSlide");
  var speed = document.querySelector(".pp-speed");

  if (!sec || !slide) return;

  var offset = 900;
  var mqReduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  function layout() {
    sec = document.getElementById("ppPandaSec");
    slide = document.getElementById("ppSlide");
    speed = document.querySelector(".pp-speed");

    if (!sec || !slide) return;

    slide.style.transform = "translateX(0px)";
    var sr = slide.getBoundingClientRect(),
      xr = sec.getBoundingClientRect();
    offset = Math.max(sr.right - xr.left + 80, 400);
    drive();
  }

  function drive() {
    if (!slide) return;
    if (mqReduce.matches) {
      slide.style.transform = "translateX(0px)";
      if (speed) speed.style.opacity = "0";
      return;
    }
    var r = sec.getBoundingClientRect(),
      vh = window.innerHeight;
    var p = Math.min(Math.max((vh - r.top) / (vh * 0.95), 0), 1);
    var e = p * p * (3 - 2 * p);
    slide.style.transform = "translateX(" + -offset * (1 - e) + "px)";
    if (speed) speed.style.opacity = p > 0.05 && p < 0.95 ? "1" : "0";
  }

  window.removeEventListener("scroll", window._driveHandler);
  window._driveHandler = function () {
    requestAnimationFrame(drive);
  };
  window.addEventListener("scroll", window._driveHandler, { passive: true });

  window.removeEventListener("resize", window._resizePandaHandler);
  window._resizePandaHandler = layout;
  window.addEventListener("resize", window._resizePandaHandler);

  layout();
};

// --- Script Block 3: Interactive Brand Footer ---
window.initBrandFooter = function () {
  var footer = document.querySelector(".pp-footer");
  if (!footer) return;

  var mascot = footer.querySelector(".pp-footer__mascot-img");
  var wordmark = footer.querySelector(".pp-footer__wordmark-text");
  var accordionTriggers = footer.querySelectorAll(
    ".pp-footer__accordion-trigger",
  );

  // 1. Mobile Accordion Toggle
  accordionTriggers.forEach(function (trigger) {
    if (trigger._hasListener) return;
    trigger._hasListener = true;

    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      var isExpanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", !isExpanded);

      // Close other accordions for premium clean interaction
      accordionTriggers.forEach(function (otherTrigger) {
        if (otherTrigger !== trigger) {
          otherTrigger.setAttribute("aria-expanded", "false");
        }
      });
    });
  });

  // 2. IntersectionObserver Viewport Reveal
  var isReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if ("IntersectionObserver" in window && !isReducedMotion) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (mascot) {
              mascot.classList.add("pp-footer__mascot-img--revealed");
            }
            if (
              wordmark &&
              wordmark.classList.contains("pp-footer__wordmark-text--animate")
            ) {
              setTimeout(function () {
                wordmark.classList.add("pp-footer__wordmark-text--revealed");
              }, 250);
            }
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px 40px 0px",
      },
    );
    observer.observe(footer);
  } else {
    // Fallback: show immediately
    if (mascot) mascot.classList.add("pp-footer__mascot-img--revealed");
    if (wordmark) wordmark.classList.add("pp-footer__wordmark-text--revealed");
  }

  // 3. Desktop Mascot Cursor Parallax
  var isParallaxEnabled = footer.getAttribute("data-parallax") === "true";
  var isTouch = window.matchMedia("(pointer: coarse)").matches;

  if (mascot && isParallaxEnabled && !isTouch && !isReducedMotion) {
    var targetX = 0,
      targetY = 0,
      targetRot = 0;
    var currentX = 0,
      currentY = 0,
      currentRot = 0;
    var activeParallax = false;
    var animationFrameId = null;

    function lerp() {
      if (
        !activeParallax &&
        Math.abs(currentX) < 0.05 &&
        Math.abs(currentY) < 0.05
      ) {
        currentX = 0;
        currentY = 0;
        currentRot = 0;
        mascot.style.setProperty("--parallax-x", "0px");
        mascot.style.setProperty("--parallax-y", "0px");
        mascot.style.setProperty("--parallax-rot", "0deg");
        animationFrameId = null;
        return;
      }

      currentX += (targetX - currentX) * 0.1;
      currentY += (targetY - currentY) * 0.1;
      currentRot += (targetRot - currentRot) * 0.1;

      mascot.style.setProperty("--parallax-x", currentX.toFixed(2) + "px");
      mascot.style.setProperty("--parallax-y", currentY.toFixed(2) + "px");
      mascot.style.setProperty("--parallax-rot", currentRot.toFixed(2) + "deg");

      animationFrameId = requestAnimationFrame(lerp);
    }

    function onMouseMove(e) {
      if (!activeParallax) {
        activeParallax = true;
        if (!animationFrameId) {
          animationFrameId = requestAnimationFrame(lerp);
        }
      }

      var bounds = footer.getBoundingClientRect();
      var x = e.clientX - bounds.left;
      var y = e.clientY - bounds.top;

      // Calculate percentage offset from center (-1 to 1)
      var pctX = (x / bounds.width) * 2 - 1;
      var pctY = (y / bounds.height) * 2 - 1;

      // Restrict mousemove values (X: max 8px, Y: max 6px, rot: max 2deg)
      targetX = pctX * 8;
      targetY = pctY * 6;
      targetRot = pctX * 2;
    }

    function onMouseLeave() {
      activeParallax = false;
      targetX = 0;
      targetY = 0;
      targetRot = 0;
    }

    // Clean up old events (prevents duplicates on Customizer section reload)
    if (footer._onMouseMove) {
      footer.removeEventListener("mousemove", footer._onMouseMove);
      footer.removeEventListener("mouseleave", footer._onMouseLeave);
    }

    footer._onMouseMove = onMouseMove;
    footer._onMouseLeave = onMouseLeave;

    footer.addEventListener("mousemove", onMouseMove, { passive: true });
    footer.addEventListener("mouseleave", onMouseLeave, { passive: true });
  }
};

// --- Script Block 4: Mobile Hamburger Menu ---
window.initMobileMenu = function () {
  var header = document.querySelector(".pp-nav");
  if (!header) return;

  var toggle = header.querySelector(".pp-menu-toggle");
  var drawer = header.querySelector(".pp-mobile-menu");

  if (!toggle || !drawer) return;

  // Cleanup existing listeners if reloaded
  if (toggle._menuHandler) {
    toggle.removeEventListener("click", toggle._menuHandler);
  }

  toggle._menuHandler = function (e) {
    e.preventDefault();
    var isExpanded = toggle.getAttribute("aria-expanded") === "true";
    var nextState = !isExpanded;

    toggle.setAttribute("aria-expanded", String(nextState));
    drawer.setAttribute("aria-hidden", String(!nextState));

    if (nextState) {
      header.classList.add("pp-nav--menu-open");
      document.body.style.overflow = "hidden";
    } else {
      header.classList.remove("pp-nav--menu-open");
      document.body.style.overflow = "";
    }
  };

  toggle.addEventListener("click", toggle._menuHandler);

  // Auto-close menu drawer when viewport scales back to desktop layout
  if (window._resizeMenuHandler) {
    window.removeEventListener("resize", window._resizeMenuHandler);
  }
  window._resizeMenuHandler = function () {
    if (window.innerWidth > 860 && header.classList.contains("pp-nav--menu-open")) {
      header.classList.remove("pp-nav--menu-open");
      toggle.setAttribute("aria-expanded", "false");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
  };
  window.addEventListener("resize", window._resizeMenuHandler);
};

// --- Script Block 5: Card Quantity Steppers ---
window.initCardQuantitySteppers = function () {
  var wraps = document.querySelectorAll(".pp-card-qty");
  wraps.forEach(function (wrap) {
    if (wrap._hasQtyHandler) return;
    wrap._hasQtyHandler = true;

    var minusBtn = wrap.querySelector(".pp-qty-minus");
    var plusBtn = wrap.querySelector(".pp-qty-plus");
    var input = wrap.querySelector(".pp-card-qty-input");

    if (!input) return;

    if (minusBtn) {
      minusBtn.addEventListener("click", function (e) {
        e.preventDefault();
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener("click", function (e) {
        e.preventDefault();
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  });
};

// --- Script Block 6: AJAX Add to Cart & Header Badge Update ---
window.initAddToCartForms = function () {
  var forms = document.querySelectorAll(".pp-card-form, .product-form");
  forms.forEach(function (form) {
    if (form._hasAddToCartHandler) return;
    form._hasAddToCartHandler = true;

    form.addEventListener("submit", function (e) {
      var submitBtn = form.querySelector('button[type="submit"]');
      var variantInput = form.querySelector('input[name="id"]');

      if (!variantInput || !variantInput.value) return;

      e.preventDefault();

      var originalText = submitBtn ? submitBtn.innerHTML : "Add to Cart";
      if (submitBtn) {
        submitBtn.classList.add("is-loading");
        submitBtn.disabled = true;
        submitBtn.innerHTML = "Adding...";
      }

      var formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (errData) {
              var errorMsg = (errData && errData.description) ? errData.description : (errData && errData.message ? errData.message : "Error adding to cart");
              throw new Error(errorMsg);
            }).catch(function (e) {
              throw e.message ? e : new Error("Error adding to cart");
            });
          }
          return res.json();
        })
        .then(function (item) {
          return fetch("/cart.js").then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          var cartBadges = document.querySelectorAll(".pp-cart");
          cartBadges.forEach(function (badge) {
            badge.textContent = cart.item_count;
          });

          if (submitBtn) {
            submitBtn.classList.remove("is-loading");
            submitBtn.classList.add("is-added");
            submitBtn.innerHTML = "Added! &#128722;";

            setTimeout(function () {
              submitBtn.classList.remove("is-added");
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalText;
            }, 2000);
          }
        })
        .catch(function (err) {
          console.warn("Add to Cart error:", err.message);
          if (submitBtn) {
            submitBtn.classList.remove("is-loading");
            submitBtn.classList.add("is-error");
            
            var errText = "SOLD OUT";
            if (err.message && err.message.toLowerCase().includes("sold out")) {
              errText = "SOLD OUT";
            } else if (err.message && err.message.length < 15) {
              errText = err.message.toUpperCase();
            } else {
              errText = "OUT OF STOCK";
            }
            
            submitBtn.innerHTML = errText;

            setTimeout(function () {
              submitBtn.classList.remove("is-error");
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalText;
            }, 2500);
          }
        });
    });
  });
};

// --- Global Initialization ---
document.addEventListener("DOMContentLoaded", function () {
  window.initFlyingPastry();
  window.initSkatingPanda();
  window.initBrandFooter();
  window.initMobileMenu();
  window.initCardQuantitySteppers();
  window.initAddToCartForms();
});

window.addEventListener("load", function () {
  window.initFlyingPastry();
  window.initSkatingPanda();
  window.initBrandFooter();
  window.initMobileMenu();
  window.initCardQuantitySteppers();
  window.initAddToCartForms();
});

// Shopify Theme Editor Reload Handler
document.addEventListener("shopify:section:load", function (event) {
  window.initFlyingPastry();
  window.initSkatingPanda();
  window.initBrandFooter();
  window.initMobileMenu();
  window.initCardQuantitySteppers();
  window.initAddToCartForms();
});

document.addEventListener("shopify:section:select", function (event) {
  window.initFlyingPastry();
  window.initSkatingPanda();
  window.initBrandFooter();
  window.initMobileMenu();
  window.initCardQuantitySteppers();
  window.initAddToCartForms();
});
